import React from 'react'
import { createRoot } from 'react-dom/client'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle'
import 'react-image-gallery/styles/scss/image-gallery.scss'
import '_styles/styles.scss'
import './index.css'

import App from './pages'

const root = createRoot(document.getElementById('root'))
root.render(<App />)
